var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgSearchBlue = function SvgSearchBlue(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 21,
    viewBox: "0 0 26 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.337 15.75C13.481 15.75 14.547 15.4088 15.444 14.8313L18.616 18.0338L20.462 16.17L17.29 12.9806C17.862 12.0619 18.2 10.9987 18.2 9.84375C18.2 6.57562 15.587 3.9375 12.35 3.9375C9.113 3.9375 6.5 6.57562 6.5 9.84375C6.5 13.1119 9.113 15.75 12.337 15.75ZM12.35 6.5625C14.144 6.5625 15.6 8.0325 15.6 9.84375C15.6 11.655 14.144 13.125 12.35 13.125C10.556 13.125 9.1 11.655 9.1 9.84375C9.1 8.0325 10.556 6.5625 12.35 6.5625ZM23.4 0H2.6C1.17 0 0 1.18125 0 2.625V18.375C0 19.8188 1.17 21 2.6 21H23.4C24.83 21 26 19.8188 26 18.375V2.625C26 1.18125 24.83 0 23.4 0ZM23.4 18.375H2.6V2.625H23.4V18.375Z",
    fill: "#1967D2"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgSearchBlue);
export default ForwardRef;